export default /* @ngInject */ function invoiceUrl(config) {
    const urlBase = `${config.accountsApiUrl}/api/v1/stripe`;

    return function(invoiceNumber) {
        return `${urlBase}/invoices/${invoiceNumber}.pdf`;
    };
}



// WEBPACK FOOTER //
// ./payments/filters/invoice-url.filter.js